import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ModalAnalise from "./modalAnalise";
import ModalDevolution from "./modaldevolution";
import { Box, Button } from "@mui/material";
import IconCopy from "../componentsStyled/icon/Iconcopy";
import IconLdn from "../componentsStyled/icon/Iconldn";
import ModalEnvio from "./modalEnvio";
import ModalEnvioPendente from "./modalEnvioPendente";
import ModalConcluido from "./modalconcluido";
import ModalRealizado from "./modalrealizado";
import Iconbag from "../componentsStyled/icon/Iconbag";

interface DetailsDevolutionProps {
  devolutionData?: devolutionData;
}

type devolutionData = {
  id: number;
  status_id: number;
  order_id: number;
  method_shipment: string;
  dateCreatedReturn: string;
  customer: {
    fullname: string;
    fone: string;
    cellphone: string;
    cep: string;
    state: string;
    city: string;
    neigh_borhood: string;
    street: string;
    number: string;
    complement: string;
  };
  products: Array<{
    name: string;
    image: string;
    quant: number;
    price: string;
    refundType: string;
    reasonSub: string;
    reasonMain: string;
    obs: string;
    variant: string;
    url_pdf: any;
  }>;
  history: Array<{
    title: string;
    date: string;
    fileIcon: string;
    status: string;
  }>;
  status: {
    title: string;
    status: string;
    msg: string;
    color: string;
  };
  coupon: any;
  ldn: {
    status: boolean;
    url: string;
  };
};

const DetailsDevolution: React.FC<DetailsDevolutionProps> = ({ devolutionData }) => {
  const [modalType, setModalType] = useState("");

  const settings = {
    dots: true,
    arrow: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };

  const closeModal = () => {
    setModalType("");
  };
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyCoupon = () => {
    if (devolutionData && devolutionData.coupon) {
      navigator.clipboard
        .writeText(devolutionData.coupon)
        .then(() => {
          setIsCopied(true);
          setTimeout(() => {
            setIsCopied(false);
          }, 2000);
        })
        .catch((err) => {
          console.error("Failed to copy coupon code", err);
        });
    }
  };

  const handleButtonClick = () => {
    if (devolutionData) {
      if (devolutionData.status && devolutionData.status.title) {
        if (devolutionData.status.title === "Em Análise") {
          setModalType("analise");
        } else if (devolutionData.status.title === "Negada") {
          setModalType("negada");
        } else if (devolutionData.status.title === "Envio Pendente") {
          setModalType("envio");
        } else if (devolutionData.status.title === "Solicitação Realizada") {
          setModalType("realizada");
        } else if (devolutionData.status.title === "Devolução Finalizada") {
          setModalType("concluido");
        } else if (devolutionData.status.title === "Reembolso Em Progresso") {
          setModalType("progresso");
        }
      }
    }
  };

  return (
    <>
      {devolutionData != null ? (
        <Box width={{ xs: "90%", md: "60%" }} paddingX={1}>
          <Box display={"flex"} flexDirection={"row"} alignItems={"center"} gap={2} ml={1} mt={2} mb={2}>
            <Iconbag width={28} />
            <p>Meu pedido</p>
          </Box>

          {/* Desktop */}
          <Box display={{ xs: "none", md: "block" }} width={"45vw"}>
            <Slider {...settings} key={devolutionData.id}>
              {Array.isArray(devolutionData.products) &&
                devolutionData.products.map((product, productIndex) => (
                  <div key={productIndex}>
                    <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                      <div>
                        <img style={{ width: 200, borderRadius: 12 }} src={product.image ?? undefined} alt={`Product_${productIndex + 1}`} />
                        <h1 style={{ fontSize: "17px" }}>N Pedido: #{devolutionData.order_id}</h1>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 10,
                            alignItems: "center",
                            border: "1px solid #ccc",
                            boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)",
                            padding: "10px",
                            borderRadius: 50,
                            height: 20,
                            width: "fit-content",
                            cursor: "pointer",
                          }}
                          onClick={handleButtonClick}>
                          <div style={{ backgroundColor: devolutionData.status.color, width: 20, height: 20, borderRadius: 100 }} />
                          <p>{devolutionData.status.title}</p>
                        </div>
                      </div>

                      <div>
                        <p style={{ margin: 0, fontSize: 23, fontWeight: 900 }}>{product.name || "-"}</p>
                        <div style={{ display: "flex", flexDirection: "row", marginTop: 10, gap: 20 }}>
                          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                            <label style={{ color: "#acacac" }}>Variação</label>
                            <p>{product.variant || "-"}</p>
                            <label style={{ color: "#acacac" }}>Preço</label>
                            <p>R${parseFloat(product.price).toFixed(2)}</p>
                            <label style={{ color: "#acacac" }}>Motivo da Devolução</label>
                            <p>
                              {product.reasonMain} - {product.reasonSub}
                            </p>
                          </div>

                          <div>
                            <label style={{ color: "#acacac" }}>Quantidade</label>
                            <p>{product.quant || "-"}</p>
                          </div>
                        </div>

                        <div className="" style={{ width: "30%", marginTop: 10 }}>
                          <label style={{ color: "#acacac" }}>Observação</label>
                          <p>{product.obs || "-"}</p>
                        </div>
                      </div>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", marginTop: 20 }}>
                      <p style={{ fontSize: 22, marginBottom: 10 }}>Solicitação</p>
                      <div style={{ display: "flex", gap: 50 }}>
                        <div>
                          <label style={{ color: "#21222D", opacity: 0.6 }}>Tipo de Reembolso</label>
                          <p>{product.refundType || "-"}</p>
                        </div>
                        <div>
                          <label style={{ color: "#929292" }}>Forma de Envio</label>
                          <p>{devolutionData.method_shipment || "-"}</p>
                        </div>
                      </div>
                    </div>

                    {devolutionData.status.title === "Negada" && devolutionData.ldn.url ? (
                      <Box marginTop={1}>
                        <Button href={devolutionData.ldn.url} target="_blank" style={{ color: "#192c53" }}>
                          <IconLdn width={24}></IconLdn>
                          Baixar Laudo de Reprova
                        </Button>
                      </Box>
                    ) : null}

                    {devolutionData.status.title == "Solicitação Finalizada" && product.refundType == "Cupom" ? (
                      <div style={{ marginTop: 10 }}>
                        <p style={{ fontSize: "12px", color: "#000", margin: "0px" }}>Pegue aqui seu Cupom de Vale Compras:</p>
                        <Button onClick={handleCopyCoupon}>
                          <p style={{ fontSize: "16px", color: "#192c53", margin: "0px 8px" }}>asdasasd{devolutionData.coupon}</p>
                          <IconCopy width={20} onClick={handleCopyCoupon}></IconCopy>
                        </Button>
                        {isCopied && <span style={{ fontSize: "12px", color: "green" }}>Cupom copiado!</span>}
                      </div>
                    ) : null}
                  </div>
                ))}
            </Slider>
          </Box>
          {/* Desktop */}

          {/* Mobile */}
          <Box display={{ xs: "block", md: "none" }}>
            <Slider {...settings} key={devolutionData.id}>
              {Array.isArray(devolutionData.products) &&
                devolutionData.products.map((product, productIndex) => (
                  <div key={productIndex}>
                    <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                      <div>
                        <img style={{ width: "35vw", borderRadius: 12 }} src={product.image ?? undefined} alt={`Product_${productIndex + 1}`} />
                      </div>

                      <div>
                        <h1 style={{ fontSize: "17px" }}>N Pedido: #{devolutionData.order_id}</h1>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 20,
                            alignItems: "center",
                            border: "1px solid #ccc",
                            boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)",
                            padding: "10px",
                            borderRadius: 50,
                            height: 20,
                            width: "fit-content",
                            cursor: "pointer",
                          }}
                          onClick={handleButtonClick}>
                          <div style={{ backgroundColor: devolutionData.status.color, width: 20, height: 20, borderRadius: 100 }} />
                          <p style={{ textAlign: "center", width: 90 }}>{devolutionData.status.title}</p>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", marginTop: 20 }}>
                          <p style={{ fontSize: 22, marginBottom: 10 }}>Solicitação</p>
                          <div style={{ display: "flex", gap: 50 }}>
                            <div>
                              <label style={{ color: "#21222D", opacity: 0.6 }}>Tipo de Reembolso</label>
                              <p>{product.refundType || "-"}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", marginTop: 20 }}>
                      <p style={{ margin: 0, fontSize: 23, fontWeight: 900 }}>{product.name || "-"}</p>
                      <div style={{ display: "flex", flexDirection: "row", marginTop: 10, gap: 20 }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                          <label style={{ color: "#acacac" }}>Variação</label>
                          <p>{product.variant || "-"}</p>
                          <label style={{ color: "#acacac" }}>Preço</label>
                          <p>R${parseFloat(product.price).toFixed(2)}</p>
                          <label style={{ color: "#acacac" }}>Motivo da Devolução</label>
                          <p>
                            {product.reasonMain} - {product.reasonSub}
                          </p>
                        </div>

                        <div>
                          <label style={{ color: "#acacac" }}>Quantidade</label>
                          <p>{product.quant || "-"}</p>
                        </div>
                      </div>

                      <div className="" style={{ width: "30%", marginTop: 10 }}>
                        <label style={{ color: "#acacac" }}>Observação</label>
                        <p>{product.obs || "-"}</p>
                      </div>

                      <div style={{ display: "flex", flexDirection: "column", marginTop: 20 }}>
                        <p style={{ fontSize: 23, fontWeight: 900, marginBottom: 10 }}>Solicitação</p>
                        <div style={{ display: "flex", gap: 50 }}>
                          <div>
                            <label style={{ color: "#21222D", opacity: 0.6 }}>Tipo de Reembolso</label>
                            <p>{product.refundType || "-"}</p>
                          </div>
                          <div>
                            <label style={{ color: "#929292" }}>Forma de Envio</label>
                            <p>{devolutionData.method_shipment || "-"}</p>
                          </div>
                        </div>
                      </div>

                      {devolutionData.status.title === "Negada" && devolutionData.ldn.url ? (
                        <Box marginTop={1}>
                          <Button href={devolutionData.ldn.url} target="_blank" style={{ color: "#192c53" }}>
                            <IconLdn width={24}></IconLdn>
                            Baixar Laudo de Reprova
                          </Button>
                        </Box>
                      ) : null}

                      {devolutionData.status.title == "Solicitação Finalizada" && product.refundType == "Cupom" ? (
                        <div style={{ marginTop: 10 }}>
                          <p style={{ fontSize: "12px", color: "#000", margin: "0px" }}>Pegue aqui seu Cupom de Vale Compras:</p>
                          <Button onClick={handleCopyCoupon}>
                            <p style={{ fontSize: "16px", color: "#192c53", margin: "0px 8px" }}>asdasasd{devolutionData.coupon}</p>
                            <IconCopy width={20} onClick={handleCopyCoupon}></IconCopy>
                          </Button>
                          {isCopied && <span style={{ fontSize: "12px", color: "green" }}>Cupom copiado!</span>}
                        </div>
                      ) : null}
                    </div>
                  </div>
                ))}
            </Slider>
          </Box>
          {/* Mobile */}
          {modalType === "analise" && <ModalAnalise isOpen={true} onRequestClose={closeModal} />}
          {modalType === "negada" && <ModalDevolution isOpen={true} onRequestClose={closeModal} />}
          {modalType === "envio" && <ModalEnvioPendente isOpen={true} onRequestClose={closeModal} />}
          {modalType === "realizada" && <ModalRealizado isOpen={true} onRequestClose={closeModal} />}
          {modalType === "progresso" && <ModalEnvio isOpen={true} onRequestClose={closeModal} />}
          {modalType === "concluido" && <ModalConcluido isOpen={true} onRequestClose={closeModal} />}
        </Box>
      ) : null}
    </>
  );
};

export default DetailsDevolution;
